import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { applyAssortmentGroupsSortOrder } from '../api/applyAssortmentGroupSortOrder'
import { REQUEST_SAVE_ASSORTMENT_GROUPS_SORT_ORDER } from '../constants'

export const requestSaveAssortmentGroupsSortOrder = createAsyncThunk(
  REQUEST_SAVE_ASSORTMENT_GROUPS_SORT_ORDER,
  applyAssortmentGroupsSortOrder
)
